// extracted by mini-css-extract-plugin
export default {"container":"NUy5Gp","title":"p5mPAf"};